function prettyConsoleLog({
  module = '',
  title = '',
  message = '',
} = {}) {
  const titleFormatted = title.length ? `${title} ` : ''

  // eslint-disable-next-line no-console
  console.log(
    `%c ${module} %c ${titleFormatted}%c${message}`,
    'background-color: #1A5DD0; color: #FFFFFF',
    'background-color: initial; color: initial; font-weight: bold;',
    'font-weight: normal;',
  )
}

export default prettyConsoleLog
